


































import {Component, Vue} from 'vue-property-decorator';

@Component
export default class AppHeader extends Vue {
  get notRsvpPage() {
    return !this.$route.path.includes('rsvp');
  }

}
